"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Olapic = require("./Olapic");
Object.keys(_Olapic).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Olapic[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Olapic[key];
    }
  });
});
